import {
  FORMULA_ESCAPE_PREFIX,
  FORMULA_TRIGGER_CHARS,
  LEADING_WHITESPACE_REGEX,
  SIGNED_NUMBER_REGEX,
  WHITESPACE_REGEX,
} from '../../constants';

// Spreadsheets evaluate a field starting with one of these, so the value is marked as text instead.
const escapeCsvFormulaValue = (
  value: string,
  isNumberColumn: boolean
): string => {
  // The client strips leading whitespace (tab and CR included) before deciding, so test what it sees.
  const testedValue = value.replace(LEADING_WHITESPACE_REGEX, '');

  // A lone sign cannot open a formula, so the shortest risky value is two characters.
  if (testedValue.length < 2) return value;
  if (!FORMULA_TRIGGER_CHARS.includes(testedValue[0])) return value;
  // A numeric column renders a number, decorations included, never a formula.
  if (isNumberColumn) return value;
  // \s covers the NBSP used for grouping, so signed numbers stay unprefixed.
  if (SIGNED_NUMBER_REGEX.test(value.replace(WHITESPACE_REGEX, ''))) {
    return value;
  }

  return `${FORMULA_ESCAPE_PREFIX}${value}`;
};

export default escapeCsvFormulaValue;
